import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const Breadcrumb = ({ items }: BreadcrumbProps) => (
  <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-sm">
    <Link to="/" className="text-[#4CAF82] hover:text-[#1B6B3A] transition-colors cursor-pointer">
      Home
    </Link>
    {items.map((item, index) => (
      <span key={index} className="flex items-center gap-2">
        <i className="ri-arrow-right-s-line text-gray-400 text-base"></i>
        {item.path ? (
          <Link to={item.path} className="text-[#4CAF82] hover:text-[#1B6B3A] transition-colors cursor-pointer">
            {item.label}
          </Link>
        ) : (
          <span className="text-gray-500">{item.label}</span>
        )}
      </span>
    ))}
  </nav>
);

export default Breadcrumb;
